var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path2, _path3, _path4, _path5, _path6, _g17, _g18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 728,
    height: 582,
    viewBox: "0 0 728 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    opacity: 0.150019,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.945 240.08C521.028 236.173 521.028 229.827 524.945 225.92L615.438 135.65C619.341 131.756 625.659 131.756 629.562 135.65L720.055 225.92C723.971 229.827 723.971 236.173 720.055 240.08L629.562 330.35C625.659 334.244 619.341 334.244 615.438 330.35L524.945 240.08Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    opacity: 0.0375744,
    filter: "url(#filter0_f_2_578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.964 76.1557C212.048 72.2485 212.048 65.9034 215.964 61.9962L266.385 11.6991C270.288 7.80542 276.607 7.80542 280.51 11.6991L330.931 61.9962C334.848 65.9034 334.848 72.2485 330.931 76.1557L280.51 126.453C276.607 130.346 270.288 130.346 266.385 126.453L215.964 76.1557Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    opacity: 0.0659412,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.439 245.149C264.522 241.242 264.522 234.897 268.439 230.99L456.478 43.413C460.381 39.5193 466.699 39.5193 470.602 43.4129L658.641 230.99C662.558 234.897 662.558 241.242 658.641 245.149L470.602 432.727C466.699 436.62 460.381 436.62 456.478 432.727L268.439 245.149Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    opacity: 0.0895647,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.744 240.969C139.508 236.733 132.632 236.742 128.386 240.988L8.45133 360.923C4.20528 365.169 4.19683 372.045 8.43245 376.28L128.073 495.921C132.309 500.157 139.184 500.148 143.43 495.902L263.366 375.967C267.612 371.721 267.62 364.845 263.384 360.61L143.744 240.969ZM62.1926 368.535L135.999 294.729L209.624 368.354L135.818 442.16L62.1926 368.535Z",
    fill: "#7367F0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Office Desk"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.293 347L201.292 490.767L201.439 490.625L201.405 497.757L284.073 579.951H273.053L201.292 508.567L201.293 579.912H192.588L192.588 511.289L123.608 579.951H111.5L192.588 499.308L192.588 347H201.293Z",
    fill: "url(#paint0_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.614 492.4C217.614 489.639 215.375 487.4 212.614 487.4H182.356C179.594 487.4 177.356 489.639 177.356 492.4V499.814C177.356 502.575 179.594 504.814 182.356 504.814H212.614C215.375 504.814 217.614 502.575 217.614 499.814V492.4Z",
    fill: "#C8DAFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Mini Board"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.25 144H281.801C284.654 144 286.967 146.304 286.967 149.146V403.6C286.967 406.363 284.781 408.618 282.037 408.741L281.781 408.747L129.23 408.156C126.384 408.145 124.083 405.844 124.083 403.009V149.146C124.083 146.304 126.396 144 129.25 144Z",
    fill: "#AFA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.778 144H274.329C277.182 144 279.495 146.304 279.495 149.146V403.6C279.495 406.363 277.309 408.618 274.566 408.741L274.309 408.747L121.758 408.156C118.913 408.145 116.612 405.844 116.612 403.009V149.146C116.612 146.304 118.925 144 121.778 144Z",
    fill: "#D5D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.141 149.317H266.755C270.019 149.317 272.665 151.953 272.665 155.204V395.436C272.665 398.687 270.019 401.323 266.755 401.323H129.141C125.877 401.323 123.231 398.687 123.231 395.436V155.204C123.231 151.953 125.877 149.317 129.141 149.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.331 393.88H213.959C216.317 393.88 218.228 395.784 218.228 398.133V411.957H172.331C169.973 411.957 168.061 410.052 168.061 407.703V398.133C168.061 395.784 169.973 393.88 172.331 393.88Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.161 407.703H221.431V411.957H217.161V407.703Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.196 393.88H211.824C214.182 393.88 216.094 395.784 216.094 398.133V407.703C216.094 410.052 214.182 411.957 211.824 411.957H170.196C167.838 411.957 165.926 410.052 165.926 407.703V398.133C165.926 395.784 167.838 393.88 170.196 393.88Z",
    fill: "#C8DAFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 349.771,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 344.5,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.408 188.173C352.408 185.964 354.199 184.173 356.408 184.173H400.246C402.455 184.173 404.246 185.964 404.246 188.173V240.014C404.246 242.224 402.455 244.014 400.246 244.014H356.408C354.199 244.014 352.408 242.224 352.408 240.014V188.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    d: "M352.408 188.173C352.408 185.964 354.199 184.173 356.408 184.173H357.679V244.014H356.408C354.199 244.014 352.408 242.224 352.408 240.014V188.173Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.763 227.879C395.073 227.879 395.267 227.544 395.113 227.275L377.805 197.118C377.648 196.845 377.254 196.848 377.102 197.124L360.501 227.281C360.353 227.55 360.548 227.879 360.855 227.879H394.763Z",
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 127_2",
    opacity: 0.44687,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.94 216.134C397.251 216.134 397.445 215.798 397.29 215.529L387.905 199.279C387.748 199.008 387.355 199.011 387.203 199.286L378.202 215.536C378.053 215.804 378.247 216.134 378.554 216.134H396.94Z",
    fill: "#63CBE8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group 61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    x: 446.771,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 441.5,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.408 188.173C449.408 185.964 451.199 184.173 453.408 184.173H497.246C499.455 184.173 501.246 185.964 501.246 188.173V240.014C501.246 242.224 499.455 244.014 497.246 244.014H453.408C451.199 244.014 449.408 242.224 449.408 240.014V188.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    x: 461.708,
    y: 203.829,
    width: 25.9191,
    height: 25.7712,
    rx: 0.4032,
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    opacity: 0.44687,
    x: 475.766,
    y: 193.782,
    width: 19.7688,
    height: 19.656,
    rx: 0.4032,
    fill: "#63CBE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    d: "M449.408 188.173C449.408 185.964 451.199 184.173 453.408 184.173H454.679V244.014H453.408C451.199 244.014 449.408 242.224 449.408 240.014V188.173Z",
    fill: "#91D6FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group 61_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    x: 542.771,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    x: 537.5,
    y: 175,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.408 188.173C545.408 185.964 547.199 184.173 549.408 184.173H593.246C595.455 184.173 597.246 185.964 597.246 188.173V240.014C597.246 242.224 595.455 244.014 593.246 244.014H549.408C547.199 244.014 545.408 242.224 545.408 240.014V188.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 571.986,
    cy: 216.714,
    rx: 18.2313,
    ry: 18.1272,
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    opacity: 0.44687,
    cx: 580.772,
    cy: 202.3,
    rx: 9.44511,
    ry: 9.3912,
    fill: "#63CBE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    d: "M545.408 188.173C545.408 185.964 547.199 184.173 549.408 184.173H550.679V244.014H549.408C547.199 244.014 545.408 242.224 545.408 240.014V188.173Z",
    fill: "#91D6FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ElementCard25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_26",
    filter: "url(#filter1_dd_2_578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 319.389C103.5 316.413 105.913 314 108.889 314H254.981C257.957 314 260.369 316.413 260.369 319.389V366.9C260.369 369.876 257.957 372.289 254.981 372.289H108.889C105.913 372.289 103.5 369.876 103.5 366.9V319.389Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    opacity: 0.465472,
    d: "M154.615 348.149C154.615 347.173 155.406 346.383 156.381 346.383H185.75C186.725 346.383 187.516 347.173 187.516 348.149C187.516 349.124 186.725 349.915 185.75 349.915H156.381C155.406 349.915 154.615 349.124 154.615 348.149Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    d: "M154.615 338.14C154.615 337.164 155.406 336.373 156.381 336.373H173.999C174.975 336.373 175.766 337.164 175.766 338.14C175.766 339.115 174.975 339.906 173.999 339.906H156.381C155.406 339.906 154.615 339.115 154.615 338.14Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M212.342 336.535C212.847 335.425 214.153 334.935 215.261 335.441C215.627 335.608 215.939 335.872 216.165 336.204L216.246 336.331L220.567 343.695C220.608 343.765 220.698 343.788 220.768 343.747L220.787 343.734L220.804 343.718L223.103 341.113C223.909 340.199 225.301 340.114 226.213 340.922C226.273 340.975 226.33 341.031 226.383 341.09L226.461 341.181L229.833 345.331C229.884 345.394 229.977 345.403 230.04 345.352L230.057 345.335L230.072 345.315L235.397 336.691C236.038 335.654 237.396 335.334 238.43 335.975C238.591 336.075 238.737 336.194 238.867 336.331L238.961 336.436L241.442 339.408C241.806 339.845 241.748 340.494 241.313 340.859C240.902 341.204 240.3 341.172 239.928 340.8L239.865 340.73L237.384 337.758C237.374 337.746 237.362 337.736 237.348 337.728C237.291 337.692 237.218 337.701 237.171 337.745L237.146 337.775L231.82 346.4C231.691 346.609 231.528 346.795 231.338 346.95C230.427 347.693 229.102 347.586 228.32 346.727L228.238 346.632L224.867 342.483C224.862 342.476 224.856 342.471 224.85 342.465C224.8 342.42 224.727 342.417 224.673 342.452L224.643 342.478L222.344 345.083C222.19 345.257 222.01 345.406 221.81 345.523C220.796 346.121 219.501 345.813 218.858 344.842L218.794 344.739L214.474 337.376C214.458 337.349 214.435 337.329 214.408 337.316C214.346 337.288 214.276 337.306 214.234 337.356L214.213 337.389L210.004 346.647C209.847 346.992 209.604 347.29 209.3 347.513L209.183 347.593L204.192 350.782C203.713 351.088 203.077 350.947 202.772 350.467C202.484 350.014 202.593 349.421 203.01 349.098L203.086 349.044L208.078 345.855C208.094 345.845 208.107 345.832 208.118 345.817L208.132 345.792L212.342 336.535Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 132.582,
    cy: 343.733,
    rx: 12.0443,
    ry: 12.0698,
    fill: "#FFBF29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard3"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_29",
    filter: "url(#filter2_dd_2_578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 171C103.5 166.582 107.082 163 111.5 163H251.977C256.395 163 259.977 166.582 259.977 171V287.215C259.977 291.633 256.395 295.215 251.977 295.215H111.5C107.082 295.215 103.5 291.633 103.5 287.215V171Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 163,
    width: 157,
    height: 133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 171C103.5 166.582 107.082 163 111.5 163H251.977C256.395 163 259.977 166.582 259.977 171V287.215C259.977 291.633 256.395 295.215 251.977 295.215H111.5C107.082 295.215 103.5 291.633 103.5 287.215V171Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    opacity: 0.414737,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.433 263.043C124.433 263.043 142.994 257.736 151.178 246.904C159.362 236.073 162.121 225.574 176.196 225.574C190.272 225.574 192.077 241.654 207.293 241.654C222.509 241.654 223.341 221.147 228.398 213.005C233.455 204.862 242.183 204.862 242.183 204.862V274.617C242.183 275.589 241.395 276.377 240.423 276.377H126.193C125.221 276.377 124.433 275.589 124.433 274.617V263.043Z",
    fill: "#FFE3B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 3_2",
    filter: "url(#filter3_d_2_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.433 264.167C124.433 264.167 142.994 258.837 151.178 247.959C159.362 237.08 162.121 226.536 176.196 226.536C190.272 226.536 192.077 242.685 207.293 242.685C222.509 242.685 223.341 222.09 228.398 213.912C233.455 205.734 242.183 205.734 242.183 205.734",
    stroke: "#FFBF29",
    strokeWidth: 2.64,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    x: 115.711,
    y: 176.082,
    width: 48.8444,
    height: 5.23279,
    rx: 2.61639,
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    opacity: 0.465472,
    d: "M115.711 191.78C115.711 190.335 116.882 189.164 118.327 189.164H135.772C137.217 189.164 138.389 190.335 138.389 191.78C138.389 193.225 137.217 194.397 135.772 194.397H118.327C116.882 194.397 115.711 193.225 115.711 191.78Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 229.536,
    cy: 179.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5",
    cx: 238.258,
    cy: 179.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    cx: 246.981,
    cy: 179.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Chair1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.068 566.984C470.068 566.092 469.371 565.355 468.48 565.306L428.454 563.108H416.18L375.993 565.307C375.102 565.356 374.405 566.092 374.405 566.984V569.965H470.068V566.984Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.792 494.996H417.681V563.565H426.792V494.996Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    width: 13.6662,
    height: 15.9994,
    rx: 0.84,
    transform: "matrix(-1 0 0 1 429.069 553.966)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.625 490.808C433.625 490.344 433.248 489.968 432.785 489.968H411.688C411.224 489.968 410.848 490.344 410.848 490.808V498.085C410.848 498.428 411.056 498.737 411.375 498.865L416.391 500.878C416.491 500.918 416.597 500.939 416.704 500.939H427.768C427.875 500.939 427.981 500.918 428.081 500.878L433.097 498.865C433.416 498.737 433.625 498.428 433.625 498.085V490.808Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 472.345 569.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 381.238 569.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 426.792 569.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.169 484.482C433.169 480.443 429.894 477.168 425.855 477.168L368.508 477.168C364.468 477.168 361.194 480.443 361.194 484.482C361.194 488.522 364.468 491.796 368.508 491.796H425.855C429.894 491.796 433.169 488.522 433.169 484.482Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.701 409.513H455.946C455.946 409.513 455.946 427.798 455.946 446.084C455.946 464.369 435.447 482.654 435.447 482.654H452.302C452.302 482.654 468.701 467.082 468.701 446.084C468.701 427.798 468.701 409.513 468.701 409.513Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.235 409.513H450.48C450.48 409.513 450.48 427.798 450.48 446.084C450.48 464.369 429.981 482.654 429.981 482.654H445.013C445.013 482.654 463.235 467.51 463.235 446.084C463.235 427.798 463.235 409.513 463.235 409.513Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.589 391.4C500.589 386.761 496.828 383 492.189 383H426.505C421.866 383 418.105 386.761 418.105 391.4V428.415C418.105 433.054 421.866 436.815 426.505 436.815H492.189C496.828 436.815 500.589 433.054 500.589 428.415V391.4Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.982 388.907C500.982 385.645 498.338 383 495.076 383C491.814 383 489.169 385.645 489.169 388.907V430.909C489.169 434.171 491.814 436.815 495.076 436.815C498.338 436.815 500.982 434.171 500.982 430.909L500.982 388.907Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.812 484.482C477.812 480.443 474.537 477.168 470.498 477.168L414.973 477.168C410.934 477.168 407.659 480.443 407.659 484.482C407.659 488.522 410.934 491.796 414.973 491.796H470.498C474.537 491.796 477.812 488.522 477.812 484.482Z",
    fill: "#91D6FF"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.609 534.415C377.609 534.415 382.855 545.01 378.554 548.349C374.247 551.688 362.871 557.946 362.871 557.946L393.011 556.052L386.311 532.944L377.609 534.415Z",
    fill: "url(#paint1_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.025 544.003C389.076 544.455 390.636 548.712 387.299 548.413C383.963 548.115 381.868 543.714 379.408 544C376.947 544.285 375.385 548.717 370.7 551.803C366.017 554.89 359.072 558.572 359.537 561.675C360.002 564.779 370.931 565.61 376.468 564.582C382.005 563.556 384.589 561.33 388.181 561.507C391.773 561.685 394.031 561.245 395.157 558.939C396.282 556.632 391.119 543.48 390.025 544.003Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.759 558.167L389.452 558.149C385 557.774 381.946 560.574 377.709 561.363C373.471 562.153 362.295 562.426 360.51 559.775C360.426 559.65 360.347 559.521 360.274 559.391C359.675 560.128 359.392 560.917 359.537 561.836C360.003 564.789 370.932 565.58 376.47 564.603C382.007 563.626 384.591 561.507 388.184 561.676L388.822 561.7C392.046 561.788 394.102 561.294 395.16 559.232C395.418 558.729 395.36 557.649 395.101 556.283C393.599 557.311 391.702 558.226 389.759 558.167Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.011 441.032C413.887 441.439 363.101 452.672 353.875 454.58C344.648 456.488 336.847 466.814 343.883 478.772C351.785 492.194 372.175 530.314 377.126 538.907C379.576 543.16 391.937 540.775 389.034 533.636C383.621 520.329 381.107 486.898 367.307 474.709C367.307 474.709 413.717 482.786 433.764 473.534C448.333 466.808 445.037 440.047 423.011 441.032Z",
    fill: "#413C75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.359 384.074C359.359 384.074 359.463 378.65 356.865 374.77C354.268 370.89 354.165 366.768 352.2 366.903C350.234 367.038 352.18 376.618 352.18 376.618C352.18 376.618 349.687 375.665 347.895 374.46C346.104 373.255 340.671 367.314 339.401 368.367C337.249 370.16 340.716 380.279 342.604 382.302C344.499 384.326 353.848 389.98 353.848 389.98L381.383 417.719L385.5 402.993L359.359 384.074Z",
    fill: "url(#paint2_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.433 381.625C410.189 391.47 402.417 409.556 399.213 414.951C395.198 421.708 388.866 424.685 381.453 419.672C379.902 418.623 375.447 414.954 375.447 414.954C376.106 408.532 378.506 403.164 382.642 398.849L385.45 401.172C385.45 401.172 393.416 380.752 399.824 368.923C405.374 358.689 420.894 366.659 414.433 381.625Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.368 401.183C385.368 401.183 383.229 408.44 382.729 408.019C382.228 407.599 383.111 399.286 383.111 399.286L385.368 401.183Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.778 343.411V352.123L439.175 346.972C439.175 346.972 441.141 338.626 442.74 332.427C443.743 328.539 446.186 315.384 436.35 316C428.293 301.796 404.827 310.587 404.64 327.94C404.415 348.811 404.599 356.937 404.599 356.937C417.868 357.698 425.337 355.78 432.778 343.411Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.313 359.997C439.313 359.997 433.362 358.6 433.156 348.85C432.949 339.099 433.094 335.77 433.094 335.77L419.986 335.534C419.986 335.534 419.843 346.401 419.841 350.332C419.836 359.889 412.807 360.672 412.807 360.672C412.807 360.672 414.009 368.558 425.886 369.225C435.16 369.748 439.313 359.997 439.313 359.997Z",
    fill: "url(#paint3_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.15 330.901C441.997 330.675 441.044 339.235 434.969 339.224C434.969 339.224 431.441 351.384 419.192 351.384C409.244 351.384 408.597 337.211 408.507 334.383C408.41 331.369 408.397 321.465 408.397 321.465L436.378 321.452L436.15 330.901Z",
    fill: "url(#paint4_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.603 330.845C434.179 331.245 434.473 332.849 433.814 332.709C430.468 331.997 416.924 332.936 415.18 325.488C413.01 330.141 412.48 331.285 407.702 332.534V318.899L437.923 316C437.923 316 437.454 330.704 436.603 330.845Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M421.554 343.215C421.554 343.215 418.636 345.685 415.257 343.372",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M419.628 346.076C418.72 346.494 417.846 346.525 417.066 346.107",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M435.554 335.505C435.494 334.132 435.913 333.041 437.313 332.822",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.984 359C430.516 363.574 421.882 365.251 413.845 360.284C400.73 386.145 397.461 417.002 400.616 451.106C419.741 458.678 435.815 457.189 449.5 448.534L437.984 359Z",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.915 534.84C344.915 534.84 345.074 547.311 334.798 551.973C324.528 556.635 317.212 556.355 318.143 559.959C319.074 563.563 345.804 563.418 348.301 560.599C350.428 558.201 355.055 535.872 356.329 537.579L344.915 534.84Z",
    fill: "url(#paint5_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.379 552.452C350.804 551.319 349.48 557.853 345.203 556.036C340.925 554.219 344.298 548.213 341.606 547.105C338.914 545.998 333.716 551.953 326.812 553.401C319.908 554.848 314.303 556.114 312.71 558.801C311.338 561.111 312.71 561.849 312.71 561.849C312.71 561.849 319.356 565.168 323.486 565.899C329.486 566.96 346.825 567.667 348.725 565.732C349.892 564.545 353.167 553.019 352.379 552.452Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.335 559.073C311.034 561.196 313.088 562.3 313.334 562.422L314.324 562.844C316.205 563.626 320.446 565.302 323.581 565.901C329.329 567 347.129 567.651 349.043 565.762C349.38 565.43 349.795 564.217 350.198 562.641L348.976 562.774C343.098 563.397 329.978 564.524 323.502 562.998C317.755 561.644 314.608 559.417 313.174 558.117C312.825 558.416 312.543 558.734 312.335 559.073Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.602 437.176C451.602 437.176 464.868 465.192 446.225 474.812C428.196 484.115 374.224 473.112 374.224 473.112C374.224 473.112 375.189 480.877 374.224 487.802C371.706 505.889 359.726 536.023 357.192 539.809C353.687 545.046 343.01 541.097 342.809 536.737C342.607 532.377 350.857 476.693 352.112 466.075C353.36 455.456 357.3 453.913 368.809 451.01C371.453 450.343 402.72 442.573 405.584 442.8C430.195 444.746 451.602 437.176 451.602 437.176Z",
    fill: "#524D87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.06 471.921C419.211 473.921 371.956 469.798 370.058 471.671C368.246 473.46 368.549 504.575 364.484 522.585L365.102 520.884C368.925 510.267 372.894 497.354 374.224 487.802C375.189 480.877 374.224 473.112 374.224 473.112L376.401 473.533C386.66 475.46 430.36 482.999 446.225 474.812C454.822 470.376 458.33 463.006 456.749 452.703C454.027 464.349 447.464 470.755 437.06 471.921Z",
    fill: "white",
    fillOpacity: 0.056108
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.657 359.021C425.289 399.537 417.871 456.979 456.5 446.986C435.98 409.206 463.875 392.202 457.553 372.676C455.391 366 437.819 358.497 437.657 359.021Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.608 375.845C437.629 377.955 449.152 402.362 444.538 406.039C439.924 409.716 431.892 410.113 431.026 412.359C429.285 416.874 437.699 428.271 456.267 446.551L456.5 446.986C438.626 414.076 457.488 396.931 458.469 380.151C456.398 376.903 454.111 375.468 451.608 375.845Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.5 360C409.78 371.838 407.511 381.127 405.394 398.503C403.629 412.975 404.513 442.84 404.513 442.84L398.68 443.987C398.68 443.987 394.51 397.848 395.904 391.907C398.244 381.938 399.829 376.113 402.918 367C404.62 361.998 414.5 360 414.5 360Z",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.06 405.017C435.06 405.017 427.444 397.392 424.807 396.507C422.17 395.622 407.723 394.559 407.82 396.559C407.931 398.701 417.228 398.578 418.087 399.632C418.947 400.685 420.142 408.888 423.392 409.697C426.635 410.506 433.357 412.9 433.357 412.9L463.282 428.362L460.094 412.901L435.06 405.017Z",
    fill: "url(#paint6_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.981 372.731C467.058 385.542 474.807 405.056 477.782 412.664C480.757 420.272 477.756 431.747 464.676 429.494C463.118 429.226 460.585 428.24 460.585 428.24C455.775 421.647 454.931 415.987 456.726 410.947L458.418 411.661C458.418 411.661 445.417 388.617 442.243 382.439C436.94 372.122 449.985 361.444 457.981 372.731Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.418 411.661C458.418 411.661 465.022 414.887 464.191 413.468C463.361 412.049 455.903 407.182 455.903 407.182L458.418 411.661Z",
    fill: "black",
    fillOpacity: 0.159856
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Table1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.638 432.555H300.638V580.135H288.638V432.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.638 432.555H294.638V580.135H286.638V432.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.475 432.555H223.475V580.135H211.475V432.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.475 432.555H217.475V580.135H209.475L209.475 432.555Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 25_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.133 432.555H505.133V580.135H493.133V432.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.133 432.555H499.133V580.135H491.133L491.133 432.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.97 432.555L422.97 432.555V580.135H410.97V432.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.97 432.555H416.97V580.135H408.97V432.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.269 429.68C292.269 428.752 293.021 428 293.949 428H506.952C507.88 428 508.632 428.752 508.632 429.68V445.32C508.632 446.248 507.88 447 506.952 447H293.949C293.021 447 292.269 446.248 292.269 445.32V429.68Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.976 429.68C200.976 428.752 201.728 428 202.656 428H414.747C415.674 428 416.427 428.752 416.427 429.68V445.32C416.427 446.248 415.674 447 414.747 447H202.656C201.728 447 200.976 446.248 200.976 445.32V429.68Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    x: 182.5,
    y: 428,
    width: 338,
    height: 9.76056,
    rx: 4.88028,
    fill: "#EFEFEF"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Pot5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.854 396.469V392.281L264.138 392.281L264.138 390.06C264.138 388.833 265.124 387.838 266.339 387.838C267.555 387.838 268.541 388.833 268.541 390.06V394.692C268.541 395.674 267.752 396.469 266.78 396.469H258.854Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.199 398.881V394.883C244.199 393.656 245.184 392.662 246.4 392.662C247.616 392.662 248.602 393.656 248.602 394.883L248.601 397.103H251.243L251.243 386.887C251.243 384.188 253.412 382 256.087 382C258.762 382 260.93 384.188 260.93 386.887V412.208H251.243L251.243 401.545L246.84 401.546C245.381 401.546 244.199 400.353 244.199 398.881Z",
    fill: "#02D3AF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.618 405.269H266.982L265.383 426.79C265.339 427.378 264.853 427.834 264.268 427.834H247.333C246.748 427.834 246.262 427.378 246.218 426.79L244.618 405.269Z",
    fill: "url(#paint7_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_58",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.618 405.269H266.982C267.6 405.269 268.101 405.774 268.101 406.398V410.91C268.101 411.533 267.6 412.039 266.982 412.039H244.618C244.001 412.039 243.5 411.533 243.5 410.91V406.398C243.5 405.774 244.001 405.269 244.618 405.269Z",
    fill: "#FFB3A4"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "FacingBack Laptop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.173 427.027C317.173 426.195 317.848 425.52 318.681 425.52H423.937C424.77 425.52 425.445 426.195 425.445 427.027C425.445 427.86 424.77 428.535 423.937 428.535H318.681C317.848 428.535 317.173 427.86 317.173 427.027Z",
    fill: "#8F84FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.496 427.027C388.496 426.195 389.171 425.52 390.003 425.52H423.937C424.769 425.52 425.444 426.195 425.444 427.027C425.444 427.86 424.769 428.535 423.937 428.535H390.003C389.171 428.535 388.496 427.86 388.496 427.027Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.019 384.056C311.743 381.905 313.42 380 315.589 380H381.858C383.67 380 385.199 381.346 385.429 383.144L390.344 421.593C390.619 423.745 388.942 425.65 386.773 425.65H320.505C318.693 425.65 317.163 424.303 316.934 422.506L312.019 384.056Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.019 384.056C311.743 381.905 313.42 380 315.589 380H379.524C381.335 380 382.865 381.346 383.095 383.144L388.01 421.593C388.285 423.745 386.608 425.65 384.439 425.65H320.505C318.693 425.65 317.163 424.303 316.934 422.506L312.019 384.056Z",
    fill: "#B1A9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7",
    cx: 348.815,
    cy: 403.551,
    rx: 4.64831,
    ry: 5.07496,
    transform: "rotate(-37 348.815 403.551)",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.5 418C438.5 417.448 438.948 417 439.5 417H485C488.038 417 490.5 419.462 490.5 422.5C490.5 425.538 488.038 428 485 428H439.5C438.948 428 438.5 427.552 438.5 427V418Z",
    fill: "#F16B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_64",
    d: "M438.5 420.2C438.5 419.648 438.948 419.2 439.5 419.2L465.533 419.2C467.356 419.2 468.833 420.677 468.833 422.5C468.833 424.323 467.356 425.8 465.533 425.8H439.5C438.948 425.8 438.5 425.352 438.5 424.8V420.2Z",
    fill: "#EAEFFF"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    width: 131.195,
    height: 198.348,
    rx: 7.68,
    transform: "matrix(-1 0 0 1 673.5 382)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    width: 95.7932,
    height: 198.348,
    rx: 7.68,
    transform: "matrix(-1 0 0 1 638.098 382)",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_67",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.768 523.304C629.768 519.062 626.33 515.624 622.088 515.624H558.315C554.073 515.624 550.635 519.062 550.635 523.304V564.316C550.635 568.558 554.073 571.996 558.315 571.996H622.088C626.33 571.996 629.768 568.558 629.768 564.316V523.304Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_68",
    d: "M602.696 515.624H577.707V522.223C577.707 524.344 579.426 526.063 581.547 526.063H598.856C600.977 526.063 602.696 524.344 602.696 522.223V515.624Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.768 403.226C629.768 402.121 628.873 401.226 627.768 401.226H558.315C554.073 401.226 550.635 404.664 550.635 408.906V439.044C550.635 443.285 554.073 446.724 558.315 446.724H627.768C628.873 446.724 629.768 445.829 629.768 444.724V403.226Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.415 398.031C612.415 393.79 608.976 390.351 604.735 390.351H540.961C536.719 390.351 533.281 393.79 533.281 398.031V439.044C533.281 443.285 536.719 446.724 540.961 446.724H604.735C608.976 446.724 612.415 443.285 612.415 439.044V398.031Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_71",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.768 460.668C629.768 456.426 626.33 452.988 622.088 452.988H558.315C554.073 452.988 550.635 456.426 550.635 460.668V501.68C550.635 505.922 554.073 509.36 558.315 509.36H622.088C626.33 509.36 629.768 505.922 629.768 501.68V460.668Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_72",
    d: "M602.696 452.988H577.707V459.587C577.707 461.708 579.426 463.427 581.547 463.427H598.856C600.977 463.427 602.696 461.708 602.696 459.587V452.988Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_73",
    d: "M585.342 390.351H560.353V396.951C560.353 399.072 562.072 400.791 564.193 400.791H581.502C583.623 400.791 585.342 399.072 585.342 396.951V390.351Z",
    fill: "#91D6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table Frame2"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.862 360.677H619.902L627.5 381.354H620.46L612.862 360.677Z",
    fill: "#7367F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.925 340.633C594.004 340.264 594.33 340 594.707 340H626.512C627.02 340 627.4 340.469 627.294 340.967L618.835 380.72C618.756 381.09 618.43 381.354 618.052 381.354H586.248C585.739 381.354 585.36 380.885 585.465 380.387L593.925 340.633Z",
    fill: "#A7C3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.165 340.633C592.244 340.264 592.57 340 592.948 340H624.752C625.261 340 625.64 340.469 625.534 340.967L617.075 380.72C616.996 381.09 616.67 381.354 616.292 381.354H584.488C583.979 381.354 583.6 380.885 583.706 380.387L592.165 340.633Z",
    fill: "url(#paint8_linear_2_578)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_77",
    d: "M593.902 342.293C593.973 341.961 594.266 341.723 594.606 341.723H622.211C622.669 341.723 623.01 342.145 622.915 342.593L615.338 378.199C615.267 378.532 614.974 378.769 614.634 378.769H587.029C586.572 378.769 586.23 378.347 586.325 377.899L593.902 342.293Z",
    fill: "#B3FFEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 341,
    width: 37,
    height: 38
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_78",
    d: "M593.902 342.293C593.973 341.961 594.266 341.723 594.606 341.723H622.211C622.669 341.723 623.01 342.145 622.915 342.593L615.338 378.199C615.267 378.532 614.974 378.769 614.634 378.769H587.029C586.572 378.769 586.23 378.347 586.325 377.899L593.902 342.293Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    cx: 602.75,
    cy: 352.385,
    rx: 3.85,
    ry: 3.76923,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9",
    cx: 591.475,
    cy: 380.654,
    rx: 17.875,
    ry: 17.5,
    fill: "#6DE9C9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10",
    cx: 619.525,
    cy: 375.538,
    rx: 21.175,
    ry: 20.4615,
    fill: "#83F2D5"
  }))))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Wom1.2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.116 297.293C102.393 294.58 101.621 278.588 110.534 273.041C101.342 253.892 122.598 234.879 137.159 246.605C146.704 242.544 154.637 258.389 145.755 270.695C149.479 291.826 141.899 297.287 128.236 297.519L114.116 297.293Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.262 293.474C114.262 293.474 119.965 292.143 120.163 282.857C120.361 273.57 120.222 270.4 120.222 270.4L132.784 270.175C132.784 270.175 132.921 280.525 132.923 284.268C132.928 294.323 139.978 293.474 139.978 293.474C139.978 293.474 138.512 301.626 127.13 302.262C118.242 302.76 114.262 293.474 114.262 293.474Z",
    fill: "url(#paint9_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.293 265.763C111.69 265.548 112.604 273.7 118.425 273.689C118.425 273.689 121.806 285.27 133.545 285.27C143.078 285.27 143.698 271.772 143.785 269.079C143.878 266.208 143.89 256.776 143.89 256.776L117.075 256.764L117.293 265.763Z",
    fill: "url(#paint10_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M131.282 277.49C131.282 277.49 134.078 279.843 137.316 277.64",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M133.127 280.215C133.997 280.614 134.835 280.643 135.583 280.245",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_2",
    d: "M117.865 270.147C117.922 268.84 117.521 267.801 116.179 267.592",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.407 264.756C116.407 264.756 119.479 268.852 120.101 268.873C120.723 268.895 120.941 263.547 120.941 263.547C124.709 263.26 134.244 261.373 136.582 256.977C138.216 260.856 141.341 262.579 143.394 262.248L143.783 270.489L144.742 253.922H115.656L116.407 264.756Z",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.552 298.329C189.552 298.329 187.878 288.988 188.48 287.097C188.994 285.462 193.852 283.104 193.852 283.104C193.852 283.104 202.302 269.736 204.152 271.097C205.656 272.201 199.751 282.057 199.751 282.057C199.751 282.057 205.136 287.714 205.06 290.243C204.985 292.772 196.272 300.689 196.272 300.689L189.552 298.329Z",
    fill: "url(#paint11_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.034 282.97C194.034 282.97 197.776 282.46 198.372 283.627C198.879 284.621 195.77 287.439 195.77 288.232C195.77 289.024 195.815 295.021 196.065 295.076C196.315 295.13 199.813 285.289 199.067 283.207C198.453 281.499 194.034 282.97 194.034 282.97Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.05 297.224C139.433 294.889 132.632 301.592 136.775 307.991C143.395 318.223 167.833 345.088 179.097 345.128C189.215 345.163 198.51 304.919 198.297 301.711C198.084 298.503 189.871 294.49 186.888 296.756C183.897 299.021 174.438 325.569 174.438 325.569C174.438 325.569 150.755 299.598 145.05 297.224Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.438 325.569C174.438 325.569 177.635 331.072 177.93 330.249C178.225 329.426 175.598 322.333 175.598 322.333L174.438 325.569Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.846 553.709C137.846 553.709 136.726 562.915 140.903 566.431C145.079 569.946 128.967 568.677 128.967 568.677L128.85 553.562L137.846 553.709Z",
    fill: "url(#paint12_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.813 561.868C130.249 561.945 130.02 566.26 131.944 566.08C133.869 565.899 137.122 561.598 139.913 563.044C142.809 564.549 158.68 574.602 159.615 577.186C160.66 580.066 153.891 580.281 149.053 580.071C144.208 579.86 141.974 577.68 139.623 577.734C137.266 577.788 136.709 579.257 134.945 579.662C133.157 580.073 128.683 580.011 128.269 578.724C127.836 577.388 127.384 561.79 128.813 561.868Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.5 366C112.5 366 122.13 458.719 122.916 467.191C123.702 475.663 122.13 481.797 121.486 490.548C120.841 499.298 123.943 554.332 123.943 554.332C128.503 557.086 133.93 557.627 140.829 554.415C140.829 554.415 147.165 485.856 147.103 470.241C147.066 460.926 148.031 367.046 148.031 367.046L112.5 366Z",
    fill: "#2B256A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.888 467.952C128.679 473.818 126.554 484.928 121.514 501.283L121.45 498.594C121.378 495.038 121.376 492.265 121.474 490.726L121.486 490.548C122.109 482.089 123.598 476.075 122.987 468.031L122.855 466.544C122.525 463.116 121.498 453.058 120.212 440.553L120.918 442.597C124.823 454.003 127.147 462.455 127.888 467.952Z",
    fill: "white",
    fillOpacity: 0.0771689
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.594 564.068L140.947 565.056C140.634 565.533 140.783 566.175 141.275 566.465L150.841 572.116C151.134 572.289 151.496 572.301 151.8 572.147L153.077 571.503C149.357 568.797 145.63 566.376 141.594 564.068Z",
    fill: "white",
    fillOpacity: 0.540975
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9594 555.204L97.7681 569.234L87.4009 569.508L89.3495 555.204H96.9594Z",
    fill: "url(#paint13_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3035 564.367C94.6508 569.908 97.4701 562.975 98.0964 563.663C99.2881 564.97 101.544 577.991 100.316 579.816C99.2334 581.432 84.5004 581.459 83.6856 579.937C82.6155 577.921 86.4864 563.751 87.3035 564.367Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5771 568.806C90.6563 568.322 91.0741 567.967 91.564 567.967H93.6384C94.1283 567.967 94.5461 568.322 94.6252 568.806L95.2412 572.569C95.3409 573.178 94.8711 573.73 94.2544 573.73H90.948C90.3312 573.73 89.8615 573.178 89.9611 572.569L90.5771 568.806Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.591 363C106.591 363 96.2658 372.305 93.5551 385.673C89.0364 407.957 91.3105 449.115 91.1767 458.14C91.0491 467.165 87.8037 472.611 86.0631 485.372C84.3224 498.132 86.0448 555.162 86.0448 555.162C90.6599 557.947 95.6641 558.146 101.167 554.995L133.485 365.977L106.591 363Z",
    fill: "#38308B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7125 371.305L103.746 371.86C100.202 378.639 98.4119 394.097 98.375 418.235L98.3744 419C98.3744 455.496 91.7861 468.353 89.1355 484.064L89.0564 484.541C87.4687 494.284 86.2795 509.898 85.4886 531.38L85.4082 526.054C85.1882 509.824 85.1833 491.821 86.063 485.372C87.8037 472.611 91.049 467.165 91.1767 458.14L91.1825 457.243C91.1802 446.663 89.172 407.289 93.5551 385.673C94.6999 380.027 97.2028 375.106 99.7125 371.305Z",
    fill: "white",
    fillOpacity: 0.0771689
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5 300.703C95.5 300.703 105.388 333.837 105.681 340.109C105.973 346.381 97.5934 364.816 99.0202 369.475C102.31 380.243 144.309 384.879 148.814 370.395C150.739 364.209 147.038 357.576 148.833 349.617C150.621 341.657 155.875 329.828 151.799 318.708C147.722 307.587 148.814 297.299 145.898 295.354C142.982 293.409 136.166 291.344 136.166 291.344C132.852 296.226 121.662 296.155 116.322 291C116.322 291 103.058 293.575 95.5 300.703Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.361 306.069C110.952 316.537 110.932 334.762 114.472 337.149C118.011 339.536 131.789 337.193 131.789 339.084C131.789 340.974 112.749 358.297 115.875 366.578C117.512 370.914 117.068 374.793 114.543 378.215L113.719 378.036C106.217 376.339 100.186 373.293 99.0202 369.475C97.5935 364.816 105.973 346.381 105.681 340.109C105.433 334.802 98.3157 310.264 96.1313 302.838C98.0617 299.345 100.805 300.422 104.361 306.069Z",
    fill: "black",
    fillOpacity: 0.0564904
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.217 360.039C125.217 360.039 131.651 357.187 133.733 357.195C135.816 357.203 137.409 357.271 137.409 357.271L137.415 360.155C137.415 360.155 147.987 361.116 149.102 361.078C150.224 361.041 145.024 368.862 141.523 370.278C137.655 371.842 124.511 367.203 124.511 367.203L125.217 360.039Z",
    fill: "url(#paint14_linear_2_578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0645 299.761C87.9583 305.675 67.2651 356.417 77.0942 363.534C85.4731 369.602 121.071 370.394 123.705 368.458C125.899 366.841 127.132 361.922 125.068 359.235C122.329 355.652 91.4412 350.477 91.4412 350.477C91.4412 350.477 102.547 323.908 104.865 319.251C112.816 303.266 107.548 291.386 96.0645 299.761Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4844 350.445C91.4844 350.445 87.9492 355.983 88.677 356.121C89.4048 356.259 94.1493 350.95 94.1493 350.95L91.4844 350.445Z",
    fill: "black",
    fillOpacity: 0.302803
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_578",
    x: 204.872,
    y: 0.624024,
    width: 137.151,
    height: 136.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07742,
    result: "effect1_foregroundBlur_2_578"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2_578",
    x: 85.5,
    y: 297,
    width: 206.869,
    height: 108.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0755213 0 0 0 0 0.582569 0 0 0 0 0.878793 0 0 0 0.229458 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_578"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.503982 0 0 0 0 0.700178 0 0 0 0 1 0 0 0 0.233829 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_578",
    result: "effect2_dropShadow_2_578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2_578",
    x: 83.5,
    y: 144,
    width: 212.477,
    height: 188.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0755213 0 0 0 0 0.582569 0 0 0 0 0.878793 0 0 0 0.229458 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_578"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.503982 0 0 0 0 0.700178 0 0 0 0 1 0 0 0 0.233829 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_578",
    result: "effect2_dropShadow_2_578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2_578",
    x: 116.113,
    y: 203.414,
    width: 134.39,
    height: 75.0731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.144395 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_578",
    x1: 73.4904,
    y1: 157.402,
    x2: 73.4904,
    y2: 579.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_578",
    x1: 398.226,
    y1: 526.858,
    x2: 396.63,
    y2: 556.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_578",
    x1: 393.595,
    y1: 354.529,
    x2: 389.355,
    y2: 415.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_578",
    x1: 447.941,
    y1: 330.528,
    x2: 436.717,
    y2: 380.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_578",
    x1: 447.184,
    y1: 321.112,
    x2: 440.524,
    y2: 353.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_578",
    x1: 362.95,
    y1: 528.061,
    x2: 361.389,
    y2: 561.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_578",
    x1: 472.879,
    y1: 387.401,
    x2: 471.371,
    y2: 426.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_578",
    x1: 268.738,
    y1: 408.373,
    x2: 247.712,
    y2: 408.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_578",
    x1: 586.58,
    y1: 330.59,
    x2: 586.58,
    y2: 381.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_578",
    x1: 105.891,
    y1: 265.408,
    x2: 116.404,
    y2: 312.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_578",
    x1: 106.719,
    y1: 256.44,
    x2: 113.026,
    y2: 287.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_578",
    x1: 184.593,
    y1: 270.663,
    x2: 195.866,
    y2: 300.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_578",
    x1: 126.644,
    y1: 549.829,
    x2: 128.06,
    y2: 568.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_578",
    x1: 85.6069,
    y1: 551.722,
    x2: 87.1183,
    y2: 568.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_578",
    x1: 118.948,
    y1: 357.043,
    x2: 120.705,
    y2: 372.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.6e6b138a1a3c0234fa0f823074fc3b4b.svg";
export { ForwardRef as ReactComponent };